import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey as bijlagenAssignedQueryKey } from '../../bijlagen/hooks/useAssignedBijlagenForEntity'
import { createSubprocesForEntity } from '../services/createSubprocesForEntity'

import { queryKey as subProcessenQueryKey } from './useSubprocessenForEntity'

export { useCreateSubprocesForEntity }

const useCreateSubprocesForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: createSubprocesForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [subProcessenQueryKey] })
      queryClient.invalidateQueries({ queryKey: [bijlagenAssignedQueryKey] })
      successAlert('Succesvol aangemaakt')
    },
  })
}
